import { jsx as _jsx } from "react/jsx-runtime";
/**
 * THIS IS AN AUTO-GENERATED FILE FROM SVGR. DO NOT MODIFY!
 *
 * File was made using the 'rushx build:icons' command.
 * To learn more see the {@link https://github.com/seequent/user-portal/blob/master/libraries/web-design-system-2/README.md#making-icons-|ReadMe}
 */
import SvgIcon from '@mui/material/SvgIcon';
import { createElement } from 'react';
function SvgArrowDownIcon(props) {
    return createElement(SvgIcon, Object.assign({ style: { width: '1em', height: '1em' }, viewBox: '0 0 24 24' }, props), _jsx("path", { fill: "currentColor", fillOpacity: 0.9, fillRule: "evenodd", d: "M12.177 12.906a.25.25 0 0 1-.354 0L8.061 9.144a.5.5 0 0 0-.707 0l-.708.707a.5.5 0 0 0 0 .707l4.293 4.293a1.5 1.5 0 0 0 2.122 0l4.293-4.293a.5.5 0 0 0 0-.707l-.708-.707a.5.5 0 0 0-.707 0z", clipRule: "evenodd" }));
}
export default SvgArrowDownIcon;
//# sourceMappingURL=ArrowDown.js.map